import React from "react";

import CountUp from 'react-countup';

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();


const AboutUs = () => {
    return (
        <>
            <div class="_reward_nft_hero">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div class="_reward_nft_hero_wrap">
                                <img src="assets/img/allblocksimg.png" alt="main" class="_reward_nft_hero_img" />
                                <h1 class="_about_title">Building an open nFT Marketplace</h1>
                                <p data-aos="zoom-in" class="_feature_nft_head_para mt-3">At Enefty, we're excited about a brand new type of
                                    digital
                                    good called a non-fungible token,
                                    or NFT. NFTs have exciting new properties: they’re unique, provably scarce, tradeable, and
                                    usable across multiple applications. Just like physical goods, you can do whatever you want
                                    with them! You could throw them in the trash, gift them to a friend across the world, or go
                                    sell them on an open marketplace.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--coundown nft wrapper--> */}
            <div class="_coundown_nft_wrapper">
                <div class="_coundown_nft_wrap">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="_coundown_nft">
                                    <div class="_coundown_nft_list">
                                        <div class="_coundown_nft_single_list">
                                            <h2 class="_coundown_nft_single_list_txt"><CountUp deplay={0} end={2021} /></h2>
                                            <p class="_coundown_nft_single_list_para">Founded</p>
                                        </div>
                                        <div class="_coundown_nft_single_list">
                                            <h2 class="_coundown_nft_single_list_txt"><CountUp deplay={0} end={50} />
                                                <span class="_coundown_nft_single_list_txt_ic">+</span>
                                            </h2>
                                            <p class="_coundown_nft_single_list_para">Employess</p>
                                        </div>
                                        <div class="_coundown_nft_single_list">
                                            <h2 class="_coundown_nft_single_list_txt"><CountUp deplay={0} end={290} /> K
                                                <span class="_coundown_nft_single_list_txt_ic">+</span>
                                            </h2>
                                            <p class="_coundown_nft_single_list_para">Artwork</p>
                                        </div>
                                        <div class="_coundown_nft_single_list">
                                            <h2 class="_coundown_nft_single_list_txt"><CountUp deplay={0} end={110} />K
                                                <span class="_coundown_nft_single_list_txt_ic">+</span>
                                            </h2>
                                            <p class="_coundown_nft_single_list_para">Auctions</p>
                                        </div>
                                        <div class="_coundown_nft_single_list">
                                            <h2 class="_coundown_nft_single_list_txt"><CountUp deplay={0} end={99} />K
                                                <span class="_coundown_nft_single_list_txt_ic">+</span>
                                            </h2>
                                            <p class="_coundown_nft_single_list_para">Creators</p>
                                        </div>
                                        <div class="_coundown_nft_single_list">
                                            <h2 class="_coundown_nft_single_list_txt">$<CountUp deplay={0} end={2} />B
                                                <span class="_coundown_nft_single_list_txt_ic">+</span>
                                            </h2>
                                            <p class="_coundown_nft_single_list_para">Creators</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--coundown nft wrapper end--> */}
            {/* <!--video2 nft wrapper--> */}
            <div class="_video2_nft_wrapper">
                <div class="_video2_nft_wrap">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-10 col-lg-11 col-md-12 mx-auto">
                                <div class="_video2_nft_head">
                                    <h3 class="_video2_nft_head_txt">Meet With Allblocks</h3>
                                    <p class="_video2_nft_head_para">The NFT
                                        marketplace with everything for everyone</p>
                                </div>
                                <div class="_video2_nft_thumb_wrap">
                                    <div class="_video2_nft_thumb">
                                        <div class="_video2_nft_thumb_img">
                                            <img src="assets/img/video2-img.png" alt="video" class="_video2_nft_thumb_img_tag" />
                                        </div>
                                        <button class="_video2_nft_thumb_btn">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="32" fill="none"
                                                viewBox="0 0 27 32">
                                                <path fill="#fff" d="M26.143 15.861.957 31.441V.28l25.186 15.58Z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--video2 nft wrapper end--> */}
            {/* <!--firms icons nft wrapper--> */}
            <div class="_firms_icons_nft_wrapper">
                <div class="_firms_icons_nft_wrap">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="_firms_icons_nft_head">
                                    <h3 class="_firms_icons_nft_head_txt">Backed by
                                        top firms & industry leaders</h3>
                                    <p class="_firms_icons_nft_head_para">who are
                                        helping us pave the way towards a brand
                                        new digital economy</p>
                                </div>

                                <div class="_firms_icons_nft_icons">
                                    <ul class="_firms_icons_nft_icons_ul">
                                        <li class="_firms_icons_nft_icon_li">
                                            <img src="assets/img/firms-ic01.svg" alt="icon" class="_firms_icons_nft_ic" />
                                        </li>
                                        <li class="_firms_icons_nft_icon_li">
                                            <img src="assets/img/firms-ic02.svg" alt="icon" class="_firms_icons_nft_ic" />
                                        </li>
                                        <li class="_firms_icons_nft_icon_li">
                                            <img src="assets/img/firms-ic03.svg" alt="icon" class="_firms_icons_nft_ic" />
                                        </li>
                                        <li class="_firms_icons_nft_icon_li">
                                            <img src="assets/img/firms-ic04.svg" alt="icon" class="_firms_icons_nft_ic" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--firms icons nft wrapper end--> */}
            {/* <!--story nft wrapper--> */}
            <div class="_story_nft_wrapper">
                <div class="_story_nft_wrap">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <div class="_story_nft_head">
                                    <h3 class="_story_nft_head_txt">Our story</h3>
                                    <p class="_story_nft_head_para">Navigating the
                                        uncharted waters of non-fungible tokens</p>
                                </div>
                            </div>
                        </div>

                        <div class="row align-items-center">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <div data-aos="zoom-out-up" data-aos-duration="3000" class="_story_nft_left">
                                    <div class="_story_nft_left_img">
                                        <img src="assets/img/story-left-img.png" alt="story" class="_story_nft_left_img_tag"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <div data-aos="zoom-in-right" class="_story_nft_r8">
                                    <p class="_story_nft_r8_para">
                                        While CryptoKitties felt like a toy to many, it represented
                                        a dramatic shift in how we interact with items in the
                                        digital world. While previous digital items lived on company servers,
                                        blockchain-native items lived on shared, public blockchains
                                        owned by no single party. They could be viewed anywhere,
                                        exchanged openly, and truly owned in a way that was never
                                        before possible in the digital world.
                                    </p>
                                    <p class="_story_nft_r8_para1">
                                        Today, we’re proud to remain the largest general marketplace
                                        for user-owned digital items, supporting multiple
                                        blockchains, with the broadest set of categories
                                        and the best prices for new emerging asset classes.
                                    </p>
                                    <p class="_story_nft_r8_para2">
                                        As a company, we’re thrilled to be at the center of this
                                        growing industry, and will continue to invest in our
                                        core infrastructure as we build the most accessible
                                        marketplace for buyers, sellers, and creators.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--story nft wrapper end--> */}
        </>
    )
}
export default AboutUs;